import WidgetSettingsPlaceholder from './component'

export default WidgetSettingsPlaceholder
